<template>
<v-btn color="primary" style="float: right;" :disabled="disableBtn()" @click="enroll">Add</v-btn>
</template>

<script>
export default {
    props: {
        semester: {
            type: Object,
            required: true
        },
        course: {
            type: Object,
            required: true
        }
    },
    computed: {
        enrolledClasses() {
            return this.$store.state.enrollment.schedule.enrolled
        }
    },
    methods: {
        disableBtn() {
            let result = false
            let restrictions = []
            if (this.course.restrictions) {
                restrictions = this.course.restrictions.split(',')
            }
            this.enrolledClasses.forEach((c) => {
                // check if student is already taking this class
                if (c.id === this.course.id) {
                    result = true
                }
                // check if student is already taking another class in same period
                if (c.period === this.course.period && c.days === this.course.days) {
                    result = true
                }
                // check class restrictions
                restrictions.forEach((r) => {
                    if (r == c.section) { //restriction is a string, section is number
                        result = true
                    }
                })
            })
            // so parents can see classes, but not interact with them
            if (this.semester.disabled) {
                result = true
            }
            return result
        },
        enroll() {
            this.$root.$emit('enrollInCourse', this.course)
        }
    }
}
</script>
